import React, {useEffect, useState} from "react";
import axios from "axios";
import {Link} from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {baseUrl} from '../Univ.js'
function LabResultView(props) {
    const [selectedDate, setSelectedDate] = useState(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000));
    const [labData, setLabData] = useState([]);
    const [iplabData, setIpLabData] = useState([]);
    useEffect(() => {
        fetchData();
        fetchIpData();
        const intervalId = setInterval(fetchData, 12000); // Fetch data every 5 seconds
        return () => clearInterval(intervalId); // Cl
    }, [selectedDate]);
    function fetchData() {
        const formattedDate = selectedDate.toISOString().substring(0, 10);
        axios.get(baseUrl + 'lab-results-view/' + formattedDate + '/')
            .then(response => {
                setLabData(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    function fetchIpData() {
        const formattedDate = selectedDate.toISOString().substring(0, 10);
        axios.get(baseUrl + 'ip-lab-results-view/' + formattedDate + '/')
            .then(response => {
                setIpLabData(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const handleDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setSelectedDate(localDate);
    };
    const columns = [
        {field: 'appt_id', headerName: 'Appt Id', width: 120},
        {
            field: 'pat.pat_id',
            headerName: 'Patient ID',
            width: 100,
            renderCell: (params) => params.row.pat.pat_id,
        },
        {
            field: 'pat.patient',
            headerName: 'Patient',
            width: 200,
            renderCell: (params) => params.row.pat.patient,
        },
        {field: 'lab_test', headerName: 'Test Name', width: 300},
        {field: 'addedby', headerName: 'Addedby', width: 100},
        {field: 'add_date', headerName: 'Result On', width: 160},
        {
            field: 'edit', headerName: 'Edit',
            renderCell: (params) => (
                <Link to={`/lab-result-entry-saved/${params.row.appt_id}/${params.row.ltest_id}`}
                      target="_blank" className="btn btn-warning">
                    Edit
                </Link>
            ),
            width: 120
        },
        {
            field: 'partial',
            headerName: 'Print',
            width: 120,
            renderCell: (params) => {
                // ✅ Show button only if printstatus === 1
                if (params.row.printstatus == 1) {
                    return (
                        <Link
                            to={`/lab-report-op/${params.row.id}/`}
                            target="_blank"
                            className="btn btn-success"
                        >
                            Partial Print
                        </Link>
                    );
                }
                // Otherwise, show nothing
                return null;
            }
        },
    ];
    const columns1 = [
        {field: 'appt_id', headerName: 'Appt Id', width: 120},
        {
            field: 'pat.pat_id',
            headerName: 'Patient ID',
            width: 100,
            renderCell: (params) => params.row.pat.pat_id,
        },
        {
            field: 'pat.patient',
            headerName: 'Patient',
            width: 200,
            renderCell: (params) => params.row.pat.patient,
        },
        {field: 'lab_test', headerName: 'Test Name', width: 300},
        {field: 'addedby', headerName: 'Addedby', width: 100},
        {field: 'add_date', headerName: 'Result On', width: 160},
        {
            field: 'edit', headerName: 'Edit',
            renderCell: (params) => (
                <Link to={`/ip-lab-result-entry-saved/${params.row.appt_id}/${params.row.ltest_id}/${params.row.ip.id}`}
                      target="_blank" className="btn btn-warning">
                    Edit
                </Link>
            ),
            width: 120
        },
        {
            field: 'partial', headerName: 'Print',
            renderCell: (params) => (
                <Link to={`/lab-report-ip/${params.row.id}/`}
                      target="_blank" className="btn btn-success">
                    Partial Print
                </Link>
            ),
            width: 120
        },
    ];
    return (
        <section className="container mt-4">
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
                        <div className="col-sm-9 col-lg-10 controls">
                            <DatePicker selected={selectedDate} onChange={handleDateChange} dateFormat="dd/MM/yyyy"/>
                        </div>
                    </div>
                </div>
            </div>
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i
                className="fa-solid fa-calendar-days"
                aria-hidden="true" style={{color: 'red'}}></i> OP Lab Result</h3>
            <DataGrid className="mt-4"
                      sx={{
                          boxShadow: 4,
                          border: 4,
                          borderColor: 'primary.light',
                          '& .MuiDataGrid-cell:hover': {
                              color: 'primary.main',
                          },
                      }}
                      rows={labData}
                      columns={columns}
                      pageSize={10}
                      slots={{
                          toolbar: GridToolbar,
                      }}
                      autoHeight
            />
            <br></br>
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}><i
                className="fa-solid fa-calendar-days"
                aria-hidden="true" style={{color: 'red'}}></i> IP Lab Result</h3>
            <DataGrid className="mt-4"
                      sx={{
                          boxShadow: 4,
                          border: 4,
                          borderColor: 'primary.light',
                          '& .MuiDataGrid-cell:hover': {
                              color: 'primary.main',
                          },
                      }}
                      rows={iplabData}
                      columns={columns1}
                      pageSize={10}
                      slots={{
                          toolbar: GridToolbar,
                      }}
                      autoHeight
            />
        </section>
    )
}
export default LabResultView;
